export enum DocumentExtractionMetaType {
  DOCUMENT_EXTRACTION_BANK_STATEMENT_META = 'DocumentExtractionBankStatementMeta'
}
